import styled, { css } from 'styled-components';

import {
  getThemeColor,
  getThemeColorWithError,
  getThemeTransition,
} from '@utils/styled';

import Typography from '@common/components/Typography';

export const QuantityPickerWrapper = styled.div`
  display: flex;
  width: 100%;
  border: 0.1rem solid ${getThemeColorWithError('bluegrey.80', 'hue.red')};
  border-radius: ${({ theme }) => theme.borderRadiuses['normal.1']}rem;
  background-color: ${getThemeColorWithError('white', 'hue.errorYellow')};
  transition: ${getThemeTransition('border-color')},
    ${getThemeTransition('color')};

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        border-color: ${getThemeColorWithError('bluegrey.60', 'hue.red')};
      }

      &:focus,
      &:focus-within {
        outline: none;
        border-color: ${getThemeColorWithError('bluegrey.15', 'hue.red')};
      }
    `};
`;

export const QuantityPickerInput = styled.input`
  position: relative;
  z-index: 1;
  display: block;
  flex-grow: 1;
  width: 100%;
  height: 5rem;
  border: none;
  background-color: transparent;
  color: ${getThemeColorWithError('grey.0', 'hue.red')};
  font-size: 2rem;
  text-align: center;

  &[type='number'] {
    /* stylelint-disable-next-line */
    -moz-appearance: textfield;
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    /* stylelint-disable-next-line */
    -webkit-appearance: none;
    margin: 0;
  }

  &:focus {
    outline: none;
  }
`;

export const QuantityPickerButton = styled.button`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 5rem;
  border: none;
  padding: 0 2rem;
  background-color: transparent;
  font-size: 3rem;
  cursor: pointer;

  &:disabled {
    cursor: not-allowed;
  }

  svg {
    fill: ${({ disabled }) =>
      getThemeColor(disabled ? 'bluegrey.80' : 'grey.0')};
  }

  ${({ isLeft }) =>
    isLeft
      ? css`
          border-top-left-radius: ${({ theme }) =>
            theme.borderRadiuses['normal.1']}rem;
          border-bottom-left-radius: ${({ theme }) =>
            theme.borderRadiuses['normal.1']}rem;
        `
      : css`
          border-top-right-radius: ${({ theme }) =>
            theme.borderRadiuses['normal.1']}rem;
          border-bottom-right-radius: ${({ theme }) =>
            theme.borderRadiuses['normal.1']}rem;
        `}

  &::after {
    content: '';
    position: absolute;
    top: 15%;
    ${({ isLeft }) => (isLeft ? 'right: -0.02rem;' : 'left: -0.02rem;')};
    bottom: 15%;
    display: block;
    width: 0.1rem;
    background-color: ${getThemeColor('bluegrey.80')};
  }
`;

export const ErrorMessage = styled(Typography).attrs({
  variant: 'body3',
})`
  margin: 0;
  ${({ theme }) => theme.getFluidSpacing('margin-top', 'equal', 5)}
  color: ${getThemeColor('hue.red')};
`;
